import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const IdentityVerify = lazy(() => import('@pages/landing/IdentityVerify'));
export const IdentityVerifyRoutes: RouteObject[] = [
  {
    path: '/identity-verify',
    element: (
      <React.Suspense>
        <IdentityVerify />
      </React.Suspense>
    ),
  },
];
